import { Institution } from './institutions.types';

export interface IStaffMember {
  id: number;
  firstName: string;
  lastName: string;
  nickName?: string;
  phone: string;
  phoneWa?: string;
  mail?: string;
  role?: StaffMemberRole;
  characterization?: StaffMemberCharacterization;
  experience?: StaffMemberExperience;
  maritalStatus?: MaritalStatus;
  numberOfChildren?: number;
  performance?: StaffMemberPerformance;
  fullAddress?: string;
  hebrewBirthDate?: string;
  birthDate?: Date;
  tags?: string[];
  status: string;
  googleRefreshToken?: string;
  googleAccessToken?: string;
  googleTokenExpiry?: number;
  isDefaultKindergartenManager?: boolean;
  isDefaultShalhavotManager?: boolean;
  isDefaultDaycareCentersManager?: boolean;

  Institution?: Institution;
  institutionRoles?: IStaffInstitutionRole[];
}

// Interface for staff-institution role connections
export interface IStaffInstitutionRole {
  id: number;
  staffMemberId: number;
  institutionId: number;
  roles: StaffMemberRole[];
  createdAt: Date;
  updatedAt: Date;

  // Relations
  staffMember?: IStaffMember;
  institution?: Institution;
}

export type User = {
  type?: string;
  publicName?: string;
  publicPhone?: string;
  aboutMe?: string;
  profileImage?: string;
  pushId?: string;
  parentId?: number;
  currentId?: number;
  reLogin?: boolean;
  videoUrl?: string;
  isAdmin?: boolean;
  spouseId?: number;
  googleAccessToken?: string;
  googleRefreshToken?: string;
  googleTokenExpiry?: Date;
  isPublic?: boolean;
} & IStaffMember;

export type StaffMember = User;

export interface StaffMembers {
  staffMembers: StaffMember[];
  total: number;
}

export enum StaffMemberRole {
  TEACHER = 'מורה',
  KINDERGARTEN_TEACHER = 'גננת',
  ASSISTANT_KINDERGARTEN_TEACHER = 'גננת משלימה',
  MANAGER = 'מנהל',
  SUPERVISOR = 'מפקח/ת',
  SYSTEM_ADMIN = 'מנהל מערכת',
  SHALIACH = 'שליח',
  REGISTRATION_MANAGER = 'מנהל/ת רישום'
}

export enum StaffMemberCharacterization {
  CHASSIDIC = 'חסידית',
  HAREDI = 'חרדית',
  RELIGIOUS_ZIONIST = 'דתית לאומית',
  NOT_SUITABLE = 'לא מתאימה'
}

export enum StaffMemberExperience {
  NEW_0_3 = 'חדשה 0-3',
  EXPERIENCED_3_8 = '3-8',
  VETERAN_9_15 = '9-15',
  SENIOR_15_PLUS = '15 ומעלה'
}

export enum MaritalStatus {
  MARRIED = 'נשואה',
  SINGLE = 'רווקה',
  DIVORCED = 'גרושה',
  WIDOWED = 'אלמנה'
}

export enum StaffMemberPerformance {
  OPTIMAL = 'מיטבי',
  IN_PROCESS = 'בתהליך',
  PROBLEMATIC = 'בעייתי'
}
